<div class="workload-item workload-item__link workload-item--fluent__link workload-item--provisioning ms-fcl-tp"
     [ngClass]="{'ms-bgc-w': fullBleedTheming}"
     [attr.aria-label]="createPlaceholderAriaLabel">
    <span class="workload-item__icon--fluent non-workload-item__icon ms-fcl-tp">
        <ohp-icon-font iconFontName="Add"
                       size="32"></ohp-icon-font>
    </span>
    <div class="workload-item__name--fluent">
        <div class="workload-item__text--fluent non-workload-link__text ms-fcl-tp">
            <span>{{ createPlaceholderText }}</span>
        </div>
    </div>
</div>
